import { useMemo } from 'react'

import { DatePicker } from 'antd'
import dayjs, { type Dayjs } from 'dayjs'

import { pick } from '@eastcoal/common/utils/object'

import { usePriceIndexChartStore } from '../../Store/hooks/useStore'

const { RangePicker } = DatePicker

export const PriceIndexChartDatePicker = () => {
  const { dateRange, setDateRange } = usePriceIndexChartStore(state =>
    pick(state, ['dateRange', 'setDateRange'])
  )

  const dayjsValue = useMemo(() => {
    return dateRange
      ? (dateRange.map(item => dayjs(item)).filter(item => item.isValid()) as [
          Dayjs,
          Dayjs
        ])
      : undefined
  }, [dateRange])

  const handleChange = (_: any, dateStrings: [string, string]) => {
    setDateRange(dateStrings)
  }

  return (
    <RangePicker
      format='YYYY-MM-DD'
      value={dayjsValue}
      onChange={handleChange}
    />
  )
}
